import { FETCH_APP_OPTIONS } from '../actions/AppConfigsActions';

const appOptionsReducer = (state = {}, action) => {
  switch (action.type) {
    case FETCH_APP_OPTIONS:
      return action.appOptions;

    default:
      return state;
  }
};

export default appOptionsReducer;
